import { FormikProps } from 'formik';

import { docsUrls } from '../DeveloperSettings.constants';
import { IVersionConfig } from '../DeveloperSettings.types';
import { EApiVersion } from '../DeveloperSettings.types';

import {
  createVersionSelectHandler,
  getErrorMessage,
  getIsVersionSelected
} from './developerSettings.helpers';

interface IGrantAwardFormValues {
  ordersReportingApiUrl: string;
  awardingV2ApiUrl: string;
  selectedAwardingVersion: string;
}

export const buildGrantAwardVersionConfigs = (
  grantAwardForm: FormikProps<IGrantAwardFormValues>,
  isAwardingV2FeatureFlagOn: boolean
): IVersionConfig[] => {
  const configs: IVersionConfig[] = [
    {
      version: EApiVersion.V1,
      label: EApiVersion.V1,
      value: grantAwardForm.values.ordersReportingApiUrl,
      initialValue: grantAwardForm.initialValues.ordersReportingApiUrl,
      onChange: (value) => grantAwardForm.setFieldValue('ordersReportingApiUrl', value),
      error: getErrorMessage(
        'ordersReportingApiUrl',
        grantAwardForm.touched,
        grantAwardForm.errors
      ),
      docsUrl: docsUrls.grantAward,
      urlDataTestId: 'grant-award-url-v1',
      isSelected: getIsVersionSelected(
        grantAwardForm.values.selectedAwardingVersion,
        EApiVersion.V1,
        isAwardingV2FeatureFlagOn
      ),
      initialIsSelected: getIsVersionSelected(
        grantAwardForm.initialValues.selectedAwardingVersion,
        EApiVersion.V1,
        isAwardingV2FeatureFlagOn
      ),
      onSelectVersion: createVersionSelectHandler(
        EApiVersion.V1,
        isAwardingV2FeatureFlagOn,
        grantAwardForm.setFieldValue
      )
    }
  ];

  if (isAwardingV2FeatureFlagOn) {
    configs.push({
      version: EApiVersion.V2,
      label: EApiVersion.V2,
      value: grantAwardForm.values.awardingV2ApiUrl,
      initialValue: grantAwardForm.initialValues.awardingV2ApiUrl,
      onChange: (value) => grantAwardForm.setFieldValue('awardingV2ApiUrl', value),
      error: getErrorMessage(
        'awardingV2ApiUrl',
        grantAwardForm.touched,
        grantAwardForm.errors
      ),
      docsUrl: docsUrls.grantAward,
      urlDataTestId: 'grant-award-url-v2',
      isSelected: grantAwardForm.values.selectedAwardingVersion === EApiVersion.V2,
      initialIsSelected: grantAwardForm.initialValues.selectedAwardingVersion === EApiVersion.V2,
      onSelectVersion: () => grantAwardForm.setFieldValue('selectedAwardingVersion', EApiVersion.V2)
    });
  }

  return configs;
};
